import { c as _c } from "react/compiler-runtime";
import "client-only";
import { useEffect, useRef } from "react";
import { useTracking } from "@/hooks/tracking/use-tracking";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
import type { ImpressionTag } from "@/vendors/Kilkaya/kilkaya.types";

/**
 * Hook to track a impression event once on component mount.
 *
 * This fires a pageview with nopv:1 (no page view increment) and the
 * specified countable tag. Used for tracking when specific UI components
 * are rendered without incrementing the page view count.
 *
 * The event will only fire once per component mount, not on rerenders.
 *
 * @param tag - The impression tag to track (e.g., "cmt-name-missing")
 */
export function useImpression(tag) {
  const $ = _c(5);
  const {
    emit
  } = useTracking();
  const consent = useCookiebotConsent();
  const hasTrackedRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== consent || $[1] !== emit || $[2] !== tag) {
    t0 = () => {
      if (hasTrackedRef.current || !consent.submitted) {
        return;
      }
      emit({
        event: "impression",
        model: {
          consent,
          tag
        }
      });
      hasTrackedRef.current = true;
    };
    t1 = [emit, consent, tag];
    $[0] = consent;
    $[1] = emit;
    $[2] = tag;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}